import { FC } from 'react'

import Link from '@atoms/Link'
import Logo from '@atoms/Logo'
import ExternalLink from '@icons/ExternalLink'

import * as style from './style.module.sass'

const ByFashionTechNews: FC = () => {
  return (
    <Link to="/" className={style.container}>
      <span>BY</span>
      <div className={style.logo}>
        <Logo withText />
      </div>
      <div className={style.external}>
        <ExternalLink />
      </div>
    </Link>
  )
}

export default ByFashionTechNews
